const warning = {
  name: 'warning',
  state: {
    warningRecordDetailData: {}
  },

  mutations: {
    SET_MODULES_WARNINGRECORD_DETAIL_DATA: (state, data) => {
      state.warningRecordDetailData = data
    }
  },

  actions: {
    // 重置预警记录详情数据
    resetWarningRecordDetailData({ commit }) {
      commit('SET_MODULES_WARNINGRECORD_DETAIL_DATA', {})
    },
    // 设置预警记录详情数据
    setWarningRecordDetailData({ commit }, data) {
      commit('SET_MODULES_WARNINGRECORD_DETAIL_DATA', data)
    }
  }
}

export default warning
